<template>
    <section class="layout">
        <div class="line-straight-down" />
        <div class="main-footer">
            <div class="icon-div">
                <div class="footer-action">
                    <ds-text-button
                        id="backToTop"
                        dense
                        leading-icon="arrow-up"
                        @click="scrollTop"
                    >
                        Back to top
                    </ds-text-button>
                </div>

                <div class="footer-action" data-qa="footer-action">
                    <ds-text-button
                        id="c2record"
                        dense
                        leading-icon="settings"
                        @click="contactLayout"
                    >
                        Customize contact record
                    </ds-text-button>
                </div>

                <div class="footer-action">
                    <ds-text-button
                        id="feedback"
                        dense
                        leading-icon="message-fill"
                        @click="feedBackPopUp"
                    >
                        Give us feedback on the new design
                    </ds-text-button>
                </div>
            </div>

            <div
                v-if="isWeather"
                class="weather"
            >
                <contact-weather
                    data-qa="weather"
                    :contact-id="contact.id.toString()"
                    :contact-weather="contactWeather"
                    :contact-state="contact.state"
                />
            </div>
        </div>
    </section>
</template>

<script>
import ContactWeather from './ContactWeather';
import axios from 'axios';

export default {
    components: {
        ContactWeather,
    },

    props: {
        contact: Object,
    },

    data() {
        return {
            isWeather: false,
            contactWeather: {
                cityName: '',
                description: '',
                iconUrl: '',
                temperature: '',
            },
            isContactLayoutEnabled: false,
        };
    },

    async created() {
        this.load();
    },

    beforeDestroy() {
        this.$root.$off('WEATHER_UPDATE');
    },

    methods: {
        scrollTop() {
            window.scrollTo(0, 0);
        },

        contactLayout() {
            if (this.isContactLayoutEnabled) {
                this.$root.$emit('DISABLE_SWAP_IN_CUSTOMIZED_CONTACT_RECORD', true);
                this.$root.$emit('CUSTOMIZED_CONTACT_RECORD', true);
            }
        },

        feedBackPopUp() {
            const config = {
                width: 'auto',
                height: 'auto',
                bodyPadding: '0',
                border_radius: '12px',
            };

            Infusion.Popup.popLightbox('', '/Help/feedbackPopup.jsp', config);
            jQuery('#cancelButton').click(() => {
                Infusion.Popup.closeLightBox();
            });
        },

        async load() {
            this.getFeatureFlagValue();
        },

        async getFeatureFlagValue() {
            try {
                const response = await axios.get('/app/contact/isContactLayoutEnabled');

                this.isContactLayoutEnabled = response.data;
            } catch (e) {
                this.$error({ message: 'Unable get featureFlag value' });
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.line-straight-down {
    border-bottom: 1px solid $color-gray-lighter;
    margin-top: $spacing-400;
}

.main-footer {
    display: flex;
    justify-content: space-between;
}

.icon-div {
    padding: $spacing-200 0;
}

.footer-action {
    margin-bottom: $spacing-100;
}

.weather {
    margin-right: $spacing-050;
}

@media only screen and ($small) {
    .weather {
        margin-right: $spacing-800;
        margin-bottom: $spacing-200;
        margin-left: $spacing-100;
    }

    .main-footer {
        display: flex;
        flex-direction: column;
    }
}
</style>
